import { Injectable } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

@Injectable()
export class GetOddDataAll {
    constructor(public _ts: TournamentsService) {}

    public get(type, matchID) {
        let dataArry = [];

        if (type === 'live') {
            dataArry = this.getAllOdds(this._ts.liveOddsList, matchID);
        } else if (type === 'pre') {
            dataArry = this.getAllOdds(this._ts.terminalOddList, matchID);
        }
        return dataArry;
    }

    private getAllOdds(allItem, _matchID): any[] {
        const data = [];
        Object.keys(allItem).forEach(x => {
            const matchOdd = x.split('/');

            if (matchOdd[0] === _matchID.toString()) {
                data.push(allItem[x]);
            }
        });

        return data;
    }
}
